import styled from 'styled-components';
import { Collapsable, CollapseArrow, LaunchIcon, P, Link, LinkProps } from 'ia-react-core';
import { AnchorHTMLAttributes, FC } from 'react';

export const StyledCollapsable = styled(Collapsable)`
  margin-top: 12px;
`;

export const StyledCollapseArrow = styled(CollapseArrow)`
  margin-right: 0px;
  color: ${({ theme }) => theme.colors.blue5};
  overflow: visible !important;
`;

export const StyledLink = styled<FC<LinkProps & AnchorHTMLAttributes<HTMLAnchorElement>>>(Link)`
  overflow: hidden !important;
  white-space: normal;
`;

export const StyledContentDiv = styled.div`
  margin-left: 24px;
  margin-top: 12px;
`;

export const StyledSectionDiv = styled.div`
  margin-bottom: 12px;
`;

export const StyledLabelP = styled(P)`
  font-weight: bolder;
`;

export const StyledLaunchIcon = styled(LaunchIcon)`
width: 18px;
height: 18px;
position:relative;
margin-bottom: -4px;
margin-left: 2px;
color: ${({ theme }) => theme.colors.blue5};
`;
